import styled from 'styled-components';

import { Flex, RichContent, Section, Typography } from 'components';
import { useProducts } from 'features/products';

const CustomSection = styled(Section)`
  position: relative;

  &::before {
    content: '';
    width: 1px;
    height: calc(100% - 16px);
    background: ${({ theme }) => theme.colors.dark_150};
    margin-top: 16px;
    margin-left: 16px;
    position: absolute;
    display: ${(props: any) => (props['data-last'] ? 'none' : 'block')};
  }
`;

const Square = styled.i`
  display: block;
  width: 16px;
  height: 16px;
  background: ${({ theme }) => theme.colors.primary_400};
  margin: 0 auto;
`;

const AreasHeader = () => {
  const { productDetails } = useProducts();

  return (
    <Flex bg="dark_350" flexDirection="column" alignItems="center" pt={{ m: 30, t: 80, d: 100 }}>
      <CustomSection flexWrap="nowrap">
        <Flex position="relative" flexGrow={0} width={32}>
          <Square />
        </Flex>

        <Flex flexGrow={1} flexDirection="column" pb={11} ml={3}>
          <Typography type="type3" color="gray_500" upper>
            {productDetails?.journey?.journeyTextHat}
          </Typography>

          <Typography type="type8" color="white" fontWeight="bold" mt={1}>
            {productDetails?.journey?.journeyTextName}
          </Typography>

          <Flex flexDirection="column" maxWidth={{ d: 600 }} pt={2}>
            <RichContent defaultType="type1" textColor="gray_500">
              {productDetails?.journey?.journeyTextDescription}
            </RichContent>
          </Flex>
        </Flex>
      </CustomSection>
    </Flex>
  );
};

export default AreasHeader;
